<div class="approw">
    <div class="row">
        <div class="col-lg-12">
            <div id="content-header" class="clearfix">
                <div class="pull-left">
                    <ol class="breadcrumb">
                        <li>
                            <a (click)="redirectToUrl('missioncontrol.dashboard', true)">{{MESSAGECONSTANTS.BREADCRUMBS.HOME}}</a>
                        </li>
                        <li class="active">
                            <span>Edit Requisition</span>
                        </li>
                    </ol>
                    <h1 class="heading-css">
                        <span>
                            Edit <i>'<span>{{jobName}}</span>'</i>
                        </span>
                    </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="row fuelux">
        <div class="col-lg-12">
            <div class="main-box clearfix">
                <div class="main-box-body clearfix wizardmainbox">
                    <div class="row d-flex align-items-center main-box-header">
                        <div class="col-xs-10">
                            <div class="workflow-header">
                                <h1 id="candidateWorkflowTitle" class="pl-0 heading-css cursor-default"
                                    style="margin-bottom: 0px; font-size:18px;">
                                    <span class="badge badge-primary text-overflow-ellipsis" style="font-size: 0.8em;">
                                        <span *ngIf="requisitionInfo?.requisitionActualNumber"
                                            tooltip="Requisition Number" container="body" placement="top"
                                            [adaptivePosition]="false">{{requisitionInfo.requisitionActualNumber}}</span>
                                        <span *ngIf="requisitionInfo?.locationLabel"
                                            tooltip="Location" container="body" placement="top"
                                            [adaptivePosition]="false"> - {{requisitionInfo.locationLabel}}</span>
                                    </span>
                                    <span class="badge badge-primary text-overflow-ellipsis" style="font-size: 0.8em;"
                                        *ngIf="requisitionInfo?.companyLabel">
                                        <span [tooltip]="requisitionInfo.companyLabel" container="body" placement="top"
                                            [adaptivePosition]="false">{{requisitionInfo.companyLabel}}</span>
                                    </span>
                                    <!--Job Type -->
                                    <span *ngIf="requisitionInfo?.jobType" tooltip="Job Type" container="body"
                                        placement="top" [adaptivePosition]="false"
                                        class="badge badge-primary cursor-default" style="font-size: 0.8em;">
                                        {{requisitionInfo.jobType}}
                                        <span *ngIf="requisitionInfo.contractDuration">({{requisitionInfo.contractDuration | contractDurationPipe}})</span>
                                    </span>
                                    <span class="badge badge-primary cursor-pointer position-relative"
                                        style="line-height:inherit; font-size:0.80em">
                                        <i class="fas fa-dollar-sign"
                                            *ngIf="requisitionInfo?.requisitionSalaryDisplayMessage != 'Not Available'"
                                            containerClass="additional-details-pop-over candidate-job-match-card-popover"
                                            placement="bottom" popoverTitle="{{requisitionInfo.salaryLabel}}"
                                            [popover]="reqSalary" container="body" triggers="mouseenter:mouseleave">
                                        </i>
                                        <i *ngIf="requisitionInfo?.requisitionSalaryDisplayMessage == 'Not Available'"
                                            class="fas fa-dollar-sign" tooltip="Job Salary not available" container="body"></i>
                                        <span *ngIf="requisitionInfo?.requisitionSalaryDisplayMessage == 'Not Available'"
                                            class="fa fa-times red candidate-job-match-card-not-available-icon"
                                            style="left:11px;"></span>
                                    </span>
                                    <span class="badge badge-primary cursor-pointer position-relative"
                                        style="line-height:inherit; font-size:0.80em">
                                        <i class="fas fa-award"
                                            *ngIf="requisitionInfo?.sponsorships && requisitionInfo.sponsorships.length > 0"
                                            containerClass="additional-details-pop-over candidate-job-match-card-popover"
                                            placement="bottom" popoverTitle="Sponsorships"
                                            [popover]="reqSponsorships" container="body" triggers="mouseenter:mouseleave">
                                        </i>
                                        <i *ngIf="!requisitionInfo?.sponsorships || requisitionInfo.sponsorships.length == 0"
                                            class="fas fa-award" tooltip="Job Sponsorships not available" container="body"></i>
                                        <span *ngIf="!requisitionInfo?.sponsorships || requisitionInfo.sponsorships.length == 0"
                                            class="fa fa-times red candidate-job-match-card-not-available-icon"
                                            style="left: 13.5px"></span>
                                    </span>
                                    <span class="badge badge-primary cursor-pointer position-relative"
                                        style="line-height:inherit; font-size:0.80em">
                                        <i class="far fa-building"
                                            *ngIf="requisitionInfo?.workLocations && requisitionInfo.workLocations.length > 0"
                                            containerClass="additional-details-pop-over candidate-job-match-card-popover"
                                            placement="bottom" popoverTitle="Work Locations"
                                            [popover]="reqWorkLocations" container="body" triggers="mouseenter:mouseleave">
                                        </i>
                                        <i *ngIf="!requisitionInfo?.workLocations || requisitionInfo.workLocations.length == 0"
                                            class="far fa-building" tooltip="Job Work locations not available" container="body"></i>
                                        <span *ngIf="!requisitionInfo?.workLocations || requisitionInfo.workLocations.length == 0"
                                            class="fa fa-times red candidate-job-match-card-not-available-icon"
                                            style="left: 14px"></span>
                                    </span>
                                    <span *ngIf="requisitionInfo">
                                        <app-requisition-card-icons [requisitionInfo]="requisitionInfo"
                                            [isRowViewActive]="false" [isAdditionalDetails]="false"
                                            [isSharedRequisitionEdit]="true">
                                        </app-requisition-card-icons>
                                    </span>
                                </h1>
                            </div>
                        </div>
                        <div class="col-xs-2">
                            <button type="button" class="btn btn-danger btn-cancel pull-right" (click)="wizardCancel()"
                                [disabled]="disableCancelButtonFlag || disableAllButtonsFlag">
                                <span class="glyphicon glyphicon-remove"></span>Cancel
                            </button>
                        </div>
                    </div>
                    <div *ngIf="loadingFlag" class="container-fluid edit-shared-req-skeleton">
                        <div class="steps-container">
                            <div class="edit-shared-req-skeleton-step skeleton-loading"></div>
                            <div class="edit-shared-req-skeleton-step skeleton-loading"></div>
                            <div class="edit-shared-req-skeleton-step skeleton-loading"></div>
                        </div>
                        <div class="edit-shared-req-skeleton-body">
                            <div class="skeleton-heading skeleton-loading width-25"></div>
                            <div class="skeleton-paragraph skeleton-loading width-75"></div>
                            <div class="skeleton-content skeleton-loading" style="height:200px"></div>
                        </div>
                    </div>
                    <div [hidden]="loadingFlag">
                    <div class="wizard" data-initialize="wizard" id="uploadReqWizard">
                        <div class="steps-container">
                            <ul class="steps">
                                <li data-step="1" data-name="jobDescription" class="active">
                                    <span class="badge">1</span>Job Description<span class="chevron"></span>
                                </li>
                                <li data-step="2" data-name="recruiters">
                                    <span class="badge">2</span>Assign Recruiters<span class="chevron"></span>
                                </li>
                                <li data-step="3" data-name="workflow">
                                    <span class="badge">3</span>Workflow Settings<span class="chevron"></span>
                                </li>
                            </ul>
                        </div>
                        <div class="actions">
                            <button type="button" class="btn btn-info btn-prev"
                                [disabled]="disablePrevButtonFlag || disableAllButtonsFlag">
                                <span class="glyphicon glyphicon-arrow-left"></span>Prev
                            </button>
                            <button type="button" class="btn btn-info btn-save"
                                [disabled]="disableSaveButtonFlag || disableAllButtonsFlag"
                                (click)="wizardSaveStepData()">
                                <span class="fa fa-save"></span>
                                <span *ngIf="!savingFlag">Save</span>
                                <span *ngIf="savingFlag">Saving ...</span>
                            </button>
                            <button type="button" class="btn btn-info btn-next" data-last="Complete"
                                [disabled]="disableNextButtonFlag || disableAllButtonsFlag">
                                Next<span class="glyphicon glyphicon-arrow-right"></span>
                            </button>
                        </div>
                        <div class="step-content" [hidden]="!showWizardSteps">
                            <div class="step-pane active sample-pane alert" data-step="1">
                                <div class="row" *ngIf="!isLoading">
                                    <app-requisition-skills [isSharedReq]="true" [allExistingSkills]="[]"
                                        [allExistingDegrees]="[]" [allExistingFieldOfStudy]="[]" [allExistingRoles]="[]"
                                        [allExistingCertificates]="[]" [allExistingJDActionWords]="[]"
                                        [timePeriods]="[]" [skillsTimePeriods]="[]">
                                    </app-requisition-skills>
                                </div>
                            </div>
                            <div class="step-pane active sample-pane alert" data-step="2">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="main-box clearfix" style="min-height: 200px;">
                                            <form #step1Form="ngForm" novalidate>
                                                <header class="main-box-header clearfix col-xs-offset-1 col-xs-10"
                                                    [hidden]="!step1Error.hasErrorFlag">
                                                    <h2 class="has-error">
                                                        <span class="help-block">
                                                            <em>*</em> {{step1Error.errorMessage}}
                                                        </span>
                                                    </h2>
                                                </header>
                                                <div class="row" style="margin-top: 40px; margin-bottom: 40px;">
                                                    <div class="col-xs-offset-1 col-xs-5">
                                                        <div class="row">
                                                            <div class="col-xs-11">
                                                                <!-- Recruiters dropdown -->
                                                                <div class="form-group"
                                                                    [ngClass]="{'has-error': step1Form.submitted && selectedRecruiters.length === 0}">
                                                                    <label for="recruiter"
                                                                        class="control-label">{{MESSAGECONSTANTS.LABLES.RECRUITERS}}
                                                                        <em>*</em> : </label>
                                                                    <ng-select name="recruiter" id="recruiter"
                                                                        [items]="recruiterList" bindLabel="name"
                                                                        dropdownPosition="bottom"
                                                                        placeholder="None selected"
                                                                        [(ngModel)]="selectedRecruiters"
                                                                        [closeOnSelect]="false" [multiple]="true"
                                                                        [loading]="loadingRecruitersFlag" required
                                                                        [ngClass]="{'multi-select-error': step1Form.submitted && selectedRecruiters.length === 0}">
                                                                        <ng-template ng-header-tmp>
                                                                            <div class="d-flex">
                                                                                <div class="mr-2 custom-ng-select-btn"
                                                                                    (click)="selectOrDeselectAllRecruiters('selectAll')">
                                                                                    Select All
                                                                                </div>
                                                                                <div class="custom-ng-select-btn"
                                                                                    (click)="selectOrDeselectAllRecruiters('deSelectAll')">
                                                                                    Select None
                                                                                </div>
                                                                            </div>
                                                                        </ng-template>
                                                                        <ng-template ng-multi-label-tmp let-items="items"
                                                                            let-clear="clear">
                                                                            <div class="ng-value d-flex"
                                                                                *ngFor="let item of items">
                                                                                <span class="ng-value-label">{{item.name}}</span>
                                                                                <span class="ng-value-icon right"
                                                                                    (click)="clear(item)"
                                                                                    aria-hidden="true">&times;</span>
                                                                            </div>
                                                                        </ng-template>
                                                                    </ng-select>
                                                                </div>
                                                            </div>
                                                            <div class="col-xs-12">
                                                                <!-- Notes -->
                                                                <div class="form-group">
                                                                    <label>Notes : </label>
                                                                    <!-- Voice Input -->
                                                                    <div class="mb-2">
                                                                        <app-voice-input
                                                                            (transcriptReady)="onVoiceTranscript($event)"
                                                                            sourceScreen="REQUISITION"
                                                                            [candidate]="formalizeActivityPayload?.candidate"
                                                                            [company]="formalizeActivityPayload?.company"
                                                                            [requisition]="formalizeActivityPayload?.requisition"
                                                                            [jobMatch]="formalizeActivityPayload?.jobMatch">
                                                                        </app-voice-input>
                                                                    </div>
                                                                    <textarea class="form-control" wrap="hard"
                                                                        style="border-width: 1px;width: 75%" rows="3"
                                                                        id="notes" name="notes"
                                                                        [(ngModel)]="requisitionNote"></textarea>
                                                                    <!-- Formalize Text -->
                                                                    <app-formalize-comment [inputText]="requisitionNote"
                                                                        (outputText)="receiveFormalizedComment($event)"
                                                                        sourceScreen="REQUISITION"
                                                                        [candidate]="formalizeActivityPayload?.candidate"
                                                                        [company]="formalizeActivityPayload?.company"
                                                                        [requisition]="formalizeActivityPayload?.requisition"
                                                                        [jobMatch]="formalizeActivityPayload?.jobMatch">
                                                                    </app-formalize-comment>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="step-pane active sample-pane alert" data-step="3">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <form novalidate>
                                            <div class="main-box clearfix" style="background-color:#e7ebee7a">
                                                <header class="main-box-header clearfix col-xs-offset-1 col-xs-10"
                                                    [hidden]="!step2Error.hasErrorFlag">
                                                    <h2 class="has-error">
                                                        <span class="help-block">
                                                            {{step2Error.errorMessage}}
                                                        </span>
                                                    </h2>
                                                </header>
                                                <div class="row" style="padding-bottom: 35px; margin-top: 10px;">
                                                    <div class="col-xs-12 emerald"
                                                        style="padding: 15px; padding-left: 30px;">
                                                        <h2>
                                                            <strong>Client's Workflow Settings</strong>
                                                        </h2>
                                                    </div>
                                                    <div class="col-xs-11" style="margin-left:25px">
                                                        <div class="row">
                                                            <div class="col-xs-9" style="margin-top:13px">
                                                                A candidate must wait for
                                                                <input type="number" name="candidatesSuspendedPeriod"
                                                                    [value]="companyLicensePreference?.candidatesSuspendedPeriod"
                                                                    disabled style="text-align:center"
                                                                    class="inline-input" min="0" max="12">
                                                                months after being 'Released' to reapply for any role
                                                                again.
                                                                <div class="checkbox-nice">
                                                                    <input type="checkbox" id="allowOverRide"
                                                                        name="allowOverRide"
                                                                        [checked]="companyLicensePreference?.allowOverride"
                                                                        disabled />
                                                                    <label for="allowOverRide" class="field-disabled"
                                                                        style="font-size:small">Allow override of
                                                                        above rule, but permission must be
                                                                        received.</label>
                                                                </div>
                                                            </div>
                                                            <div class="col-xs-9" style="margin-top:13px">
                                                                <label>
                                                                    A candidate can be positioned for multiple roles at
                                                                    the same time:
                                                                </label>
                                                                <div class="comp-management-radio"
                                                                    style="display:inline-block">
                                                                    <input type="radio" name="multipleRolesMatch"
                                                                        id="multipleRolesMatchEnable"
                                                                        [checked]="companyLicensePreference?.multipleRolesMatchEnabled === true"
                                                                        disabled>
                                                                    <label for="multipleRolesMatchEnable"
                                                                        class="field-disabled">Yes</label>
                                                                </div>
                                                                <div class="comp-management-radio"
                                                                    style="display:inline-block">
                                                                    <input type="radio" name="multipleRolesMatch"
                                                                        id="multipleRolesMatchDisable"
                                                                        [checked]="companyLicensePreference?.multipleRolesMatchEnabled === false"
                                                                        disabled>
                                                                    <label for="multipleRolesMatchDisable"
                                                                        class="field-disabled">No</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row" style="padding-bottom: 35px; margin-top: 10px;">
                                                        <div class="col-xs-12 emerald"
                                                            style="padding: 15px; padding-left: 40px;">
                                                            <h2>
                                                                <strong>Client's workflow steps</strong>
                                                            </h2>
                                                        </div>
                                                        <div class="col-xs-11 nopointerevents" style="margin-left:25px">
                                                            <div class="row">
                                                                <div class="col-xs-10 steps-wrapper"
                                                                    style="display:flex; margin-top:1em">
                                                                    <div class="dnd-step-box-key col-xs-2">
                                                                        <span>{{jobType}}:</span>
                                                                    </div>
                                                                    <div style="display:flex" class="col-xs-10">
                                                                        <div style="display:flex">
                                                                            <div class="text-center dnd-step-box"
                                                                                *ngFor="let step of (companyLicensePreference?.workflowStepsOrder || {})[jobType]">
                                                                                <div>{{step}}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #reqSalary>
    <p>
        <span>{{requisitionInfo?.requisitionSalaryDisplayMessage}}</span>
    </p>
</ng-template>

<ng-template #reqSponsorships>
    <p *ngIf="requisitionInfo?.sponsorshipsDisplayMessage == 'Not Available' || requisitionInfo?.sponsorshipsDisplayMessage == 'Sponsorship information not specified'">
        {{requisitionInfo.sponsorshipsDisplayMessage}}
    </p>
    <p class="text-left"
        *ngFor="let sponsorship of (requisitionInfo?.sponsorshipsDisplayMessage !== 'Not Available' && requisitionInfo?.sponsorshipsDisplayMessage !== 'Sponsorship information not specified' ? requisitionInfo.sponsorships : []); let i = index">
        {{i + 1}}. {{sponsorship}}
    </p>
</ng-template>

<ng-template #reqWorkLocations>
    <p *ngIf="requisitionInfo?.workLocations == null">
        <span>Not Available</span>
    </p>
    <p class="text-left" *ngFor="let workLocation of requisitionInfo?.workLocations; let i = index">
        {{i + 1}}. {{workLocation.name}}
    </p>
</ng-template>
